<template>
  <div class="container">
    <h5 v-if="isNull" class="header">Adauga servicii</h5>
    <h5 v-else class="header">Editeaza servicii</h5>
    <EditServicii v-if="currentOferta" :serv_obj="isNull ? servicii : currentOferta.serv_obj" :tip="'oferta'" :id="currentOferta.id_oferta"></EditServicii>
    <!-- <pre>{{currentOferta}}</pre> -->
  </div>
</template>

<script>
import EditServicii from "@/components/Productie/EditServicii";

export default {
  name: "OfertaServicii",
  data() {
    return {
      servicii: [
        {
          nr: "1",
          denumire: "",
          cantitate: null,
          pret: null,
          um: "",
          pret_v: null,
          marja: null,
          pret_t: null
        }
      ]
    };
  },
  components: {
    EditServicii
  },
  computed: {
    currentOferta() {
      return this.$store.getters.currentOfertaProductie;
    },
    isNull() {
      if (this.currentOferta.serv_obj) {
        return false;
      } else {
        return true;
      }
    }
  },
  methods: {},
  created: function() {
    this.$store.dispatch("fetchOfertaProductie", this.$route.params.id);
  },
  mounted: function() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
